import "../../Styles/Loader.css"


export default function MusicLoader() {
    return (
      <div className="music-loader" aria-label="Loading">
        <span /><span /><span /><span /><span />
      </div>
    );
  }
  